module.exports = __webpack_public_path__ + "static/img/ccod3.6215890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ccod3.png
// module id = aO+E
// module chunks = 0